import BaseComponent from '../../../../../common/js/BaseComponent';

export default class Stock extends BaseComponent {
    init(): void {
        this.initEvents();
    }

    static getStockDetailLink() {
        return $('#show-stock-details');
    }

    static getStocksDetail() {
        return $('#stock-details');
    }

    static getArrowIcon() {
        return $('.min-stock');
    }

    initEvents(): void {
        this.initStockClick();
        this.initStockDetail();
        this.initSearch();

    }

    initStockClick() {
        var clickableDivs = document.querySelectorAll('.clickable-div');
        clickableDivs.forEach(function(div) {
            div.addEventListener('click', function() {
                window.location.href = div.getAttribute('data-href');
            });
        });
    }

    initSearch() {
        const searchInput = document.querySelector('.search-shop input');
        const listItems = document.querySelectorAll('.list .shop-list');

        // @ts-ignore
        if(searchInput) {
            searchInput.addEventListener('input', function () {
                const searchTerm = this.value.toLowerCase();
                listItems.forEach(item => {
                    const localText = item.querySelector('.local').textContent.toLowerCase();
                    const stockText = item.querySelector('.stock').textContent.toLowerCase();
                    const addressText = item.querySelector('.address').textContent.toLowerCase();
                    if (localText.includes(searchTerm) || stockText.includes(searchTerm) || addressText.includes(searchTerm)) {
                        item.classList.remove('hidden');
                    } else {
                        item.classList.add('hidden');
                    }
                });
            });
        }
    }

    initStockDetail() {
        const allStockLink = Stock.getStockDetailLink();
        const stocksDetails = Stock.getStocksDetail();
        const arrowIcon = Stock.getArrowIcon();
        if (allStockLink && stocksDetails) {
            allStockLink.on('click', (e: Event) => {
                e.preventDefault();
                arrowIcon.toggleClass('open');
                if (stocksDetails.hasClass('d-none')) {
                    // Si la div est cachée, enlève la classe d-none pour l'afficher
                    stocksDetails.removeClass('d-none');
                } else {
                    // Sinon, ajoute la classe d-none pour la cacher
                    stocksDetails.addClass('d-none');
                }
            });
        }
    }
}
